<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-delete" scrollable centered button-size="sm">
      <template #modal-title>
        <i class="fas fa-columns"></i> CRM - Excluir Quadro
      </template>
      <div class="form-group row pt-3 pb-3">
        <div class="col-md-12 text-center">
          <h5> Deseja realmente excluir o quadro <strong>{{boardName}}</strong>?</h5><br>
          <button type="button" class="btn btn-default btn-sm" @click="hideModal" v-b-tooltip.hover :title="'Não'"><i class="fas fa-times-circle"></i><span class="d-md-down-none"> Não</span></button>&nbsp;
          <button type="button" class="btn btn-danger btn-sm" @click="onDelete" v-b-tooltip.hover :title="'Sim'" ><i class="fas fa-minus-circle"></i><span class="d-md-down-none"> Sim</span></button>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          &nbsp;
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import BoardRepository from '@/shared/http/repositories/crm/board.js'

export default {
  name: 'CRMNew',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null
    }
  },
  computed: {
    boardName () {
      let result = ''
      if (this.data && this.data.nome) {
        result = this.data.nome
      }
      return result
    }
  },
  methods: {
    showModal () {
      this.$refs['modal-delete'].show()
    },
    hideModal () {
      this.$refs['modal-delete'].hide()
    },
    onLoad () { },
    onDelete () {
      if (this.data) {
        loading.push()
        BoardRepository.Delete(this.data.id)
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
            }
            this.hideModal()
            this.$emit('Back')
          })
          .catch(this.onException)
      } else {
        toast.success('Não foi possível localizar o Quadro!')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/modal/crmdeletemodal.vue